export default "__VITE_ASSET__BwAGqqxm__"